module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/email-f53cbd01cba630ac5fad586bf8d401ac.png";